"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'socialMediaPlan.drawer.preview': 'Treść i podgląd',
    'socialMediaPlan.drawer.ai': 'Analiza AI',
    'socialMediaPlan.drawer.platforms': 'Platformy',
    'socialMediaPlan.drawer.date': 'Data',
    'socialMediaPlan.drawer.type': 'Typ',
};
